import { toPlainText } from 'next-sanity';

export const slugify = text => {
  // Add defensive check to ensure text is a string
  if (!text || typeof text !== 'string') {
    console.error('Invalid text received in slugify:', text);
    return '';
  }

  const a = text
    .toString() // Ensure it's a string
    .toLowerCase()
    .trim() // Remove leading/trailing whitespace
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars except -
    .replace(/--+/g, '-'); // Replace multiple - with single -

  return a;
};
// Update your extractHeadings function:
export function extractHeadings(blocks) {
  if (!blocks) return [];
  const headings = [];

  blocks.forEach(block => {
    // Check if it's a heading block (h2, h3, h4) and has children
    if (
      block._type === 'block' &&
      ['h2', 'h3', 'h4'].includes(block.style) &&
      block.children &&
      block.children.length > 0
    ) {
      // Instead of using toPlainText directly, first try to extract the text from children
      let headingText = '';

      // Safely extract text from block.children
      if (block.children) {
        headingText = block.children
          .map(child => (child.text || '').trim())
          .filter(Boolean)
          .join(' ');
      }

      // Fallback to toPlainText if needed
      if (!headingText) {
        try {
          headingText = toPlainText([block]);
        } catch (e) {
          console.error('Error converting block to plain text:', e);
          return;
        }
      }

      // Only proceed if we have valid text
      if (headingText && typeof headingText === 'string' && headingText.trim()) {
        const slug = slugify(headingText.trim());

        headings.push({
          text: headingText,
          slug,
          level: parseInt(block.style.slice(1)), // Extract level number from h2, h3, etc.
        });
      }
    }
  });

  return headings;
}

// And update your slugify function to be more defensive:

export const upperFirst = text => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
};

export const cx = (...classNames) => classNames.filter(Boolean).join(' ');

export const shuffle = <T>(a: T[]) =>
  [...a].map(
    (_, i, arr) =>
      ([arr[i], arr[Math.floor(Math.random() * (i + 1))]] = [
        arr[Math.floor(Math.random() * (i + 1))],
        arr[i],
      ]),
  ) && a;
